import React, { useState } from 'react';

// Sortable tables (Competitors, Found subs): click a column title to sort by
// it, again to flip. A column is { key, label, value?, render }; one without
// `value` doesn't sort. Empty values go last either way.

export const th = { textAlign: 'left', padding: '6px 8px', color: '#888', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase', whiteSpace: 'nowrap' };
export const td = { padding: '6px 8px', borderTop: '1px solid #222', whiteSpace: 'nowrap' };

export function useSort(initial) {
  const [sort, setSort] = useState(initial);
  const toggle = (key) => setSort(s => ({ key, dir: s.key === key && s.dir === 'desc' ? 'asc' : 'desc' }));
  return [sort, toggle];
}

export function sortRows(rows, sort, columns) {
  const col = columns.find(c => c.key === sort.key);
  if (!col || !col.value) return rows;
  const sign = sort.dir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const x = col.value(a), y = col.value(b);
    if (x == null || y == null) return x == null ? (y == null ? 0 : 1) : -1;
    return (typeof x === 'string' ? x.localeCompare(y) : x - y) * sign;
  });
}

export function HeaderCell({ col, sort, onSort }) {
  if (!col.value) return <th style={th}>{col.label}</th>;
  const on = sort.key === col.key;
  return <th style={{ ...th, cursor: 'pointer', color: on ? '#ff4500' : th.color }} onClick={() => onSort(col.key)}>{col.label}{on ? (sort.dir === 'asc' ? ' ↑' : ' ↓') : ''}</th>;
}
